<section class="sso-card" aria-labelledby="sso-card-mappings">
  <p class="sso-card__eyebrow" id="sso-card-mappings">Role mappings</p>
  <p class="sso-card__hint mt-0 mb-3">
    Someone in more than one mapped group gets the mapping with the lowest
    priority number. Someone in no mapped group can't sign in.
  </p>

  @if (hasUnknownRole) {
    <div class="alert alert-danger" role="alert">
      One of these mappings uses a role this screen doesn't recognize, so it
      can't be edited here.
    </div>
  }

  @if (rows.length > 0) {
    <table class="sso-mappings">
      <thead>
        <tr>
          <th scope="col">IdP group</th>
          <th scope="col">VIVE role</th>
          <th scope="col" class="sso-mappings__priority">Priority</th>
          <th scope="col" class="sso-mappings__remove"></th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track $index; let i = $index) {
          <tr>
            <td>
              <input
                class="form-control"
                maxlength="256"
                aria-label="IdP group"
                [disabled]="hasUnknownRole"
                [(ngModel)]="row.idpGroup"
              />
            </td>
            <td>
              <select
                class="form-select"
                aria-label="VIVE role"
                [disabled]="hasUnknownRole"
                [(ngModel)]="row.role"
              >
                <option [ngValue]="null" disabled></option>
                @for (role of roleOptions; track role) {
                  <option [ngValue]="role">{{ roleLabels[role] }}</option>
                }
              </select>
            </td>
            <td>
              <input
                type="number"
                min="0"
                step="1"
                class="form-control"
                aria-label="Priority"
                [disabled]="hasUnknownRole"
                [(ngModel)]="row.priority"
              />
            </td>
            <td>
              @if (!hasUnknownRole) {
                <button
                  type="button"
                  class="btn btn-ghost btn-sm"
                  aria-label="Remove mapping"
                  (click)="removeRow(i)"
                >
                  <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (!hasUnknownRole && rows.length < maxMappings) {
    <button
      type="button"
      class="btn btn-ghost btn-sm px-0 mt-2"
      (click)="addRow()"
    >
      <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Add mapping
    </button>
  }

  @for (warning of fullAdminWarnings; track $index) {
    <div class="alert alert-warning mb-0 mt-3">{{ warning }}</div>
  }

  @if (error) {
    <div class="alert alert-danger mb-0 mt-3" role="alert">{{ error }}</div>
  }

  <div class="sso-card__foot">
    <button
      type="button"
      class="btn btn-primary btn-sm"
      [disabled]="!canSave"
      (click)="save()"
    >
      Save mappings
    </button>
  </div>
</section>
